import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CallbackWidget from "@/components/CallbackWidget";
import CookieBanner from "@/components/CookieBanner";

export default function PageLayout({ children }) {
  return (
    <div className="bg-[#F6F8F3] text-[#3D3B3A] min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
      <CallbackWidget />
      <CookieBanner />
    </div>
  );
}
